module.exports = __webpack_public_path__ + "img/tick-circle-1.35c61a3e.svg";